angular.module('bmsApp.dashboard')
	.controller('DashboardOverviewCtrl', function ($scope,
												   $rootScope,
												   $state,
												   $q,
												   $timeout,
												   $ngBootbox,
												   DashboardApiSvc,
												   FranchiseSvc,
												   SMScheduleSvc,
												   SMJobSvc,
												   ActivitySvc,
												   TGProductSvc,
												   CustomerSvc,
												   Upload,
												   WorkflowTaskSvc,
												   WorkflowTaskNoteSvc,
												   TicketSvc) {

		var self = this;

		self.methods = {
			init: init,
			onTicketClick: onTicketClick,
			onSetTaskStatus: onSetTaskStatus,
			onAcceptDeclineInvite: onAcceptDeclineInvite,
			onSubmitNote: onSubmitNote,
			onNoteDrag: onNoteDrag,
			onUploadFiles: onUploadFiles,
			onMarkTechNotificationConfirmed: onMarkTechNotificationConfirmed,
		};

		$rootScope.$on('onTickedAdded', function() {
			init();
		});

		function init() {
			var dt = moment().format('YYYY-MM-DD');
			var ticketParams = {
				filter: {
					open: true
				}
			};

			var promises = {
				businessInfo: FranchiseSvc.read(),
				todaysTasks: SMScheduleSvc.forDate(dt),
				techNotifications: SMJobSvc.unconfirmedTechnicianJobNotifications(),
				activity: ActivitySvc.upcoming(),
				lowStock: TGProductSvc.lowStockIndicator(),
				anniversaries: CustomerSvc.upcomingAnniversaries(),
				tickets: TicketSvc.index(ticketParams),
				workflowTasks: WorkflowTaskSvc.index(),
				resources: DashboardApiSvc.resources(),
			};

			$q.all(promises).then(function(responses) {
				self.franchise = responses.businessInfo.data.franchise;
				self.todaysTasks = responses.todaysTasks.data.visit_collection;
				self.techNotifications = responses.techNotifications.data.job_collection;
				self.lowStock = responses.lowStock.data.product_collection;
				self.tickets = responses.tickets.data.tickets;
				self.workflowTasks = responses.workflowTasks.data.workflow_tasks;
				self.resources = responses.resources.data.resources;

				self.anniversaries = {
					customers: responses.anniversaries.data.customer_collection,
					birthdays: responses.anniversaries.data.employee_birthday_collection,
					employee_anniversaries: responses.anniversaries.data.employee_anniversary_collection
				};

				var collection;
				if (responses.activity.data.activity_collection.length > 0) {
					collection = {};
					angular.forEach(responses.activity.data.activity_collection, function (value, key) {
						var startDate = new moment(value.start);
						var startDateString = startDate.format('YYYY-DD-MM');
						if (angular.isObject(collection[startDateString]) !== true) {
							collection[startDateString] = {
								date: startDate,
								items: []
							};
						}
						collection[startDateString]['items'].push(value);
					});
				}
				else {
					collection = null;
				}
				self.activities = collection;

			});
		}

		function onTicketClick(ticket) {
			$state.go('main.dashboard.tickets.save', {ticketId: ticket.id});
		}

		function onSetTaskStatus(task, status) {
			let params = {
				task_id: task.id,
				status: status,
			};

			return WorkflowTaskSvc.setStatus(params).then(function(response) {
				angular.extend(task, {
					status: response.data.status,
				});

				if (task.status.value === 'complete') {
					self.workflowTasks.splice(self.workflowTasks.indexOf(task), 1);
				}
			});
		}

		function onSubmitNote(task, note) {
			let params = {
				task_id: task.id,
				note: note.note,
				files: note.files,
			};

			return WorkflowTaskNoteSvc.save(params).then(function(response) {
				task.notes.push(response.data.workflow_note);
				angular.extend(note, {
					note: '',
					files: [],
				})
			});
		}

		function onNoteDrag ($isDragging, $class, $event, note) {
			$timeout(function() {
				angular.extend(note, {
					isDragging: $isDragging,
				});
			});
		}

		function onUploadFiles(files, model, type) {
			if (!files.length) {
				model.isDragging = false;
				model.uploadingInProgress = false;
				return;
			}
			model.uploadingInProgress = true;
			if (!angular.isObject(model.files)) {
				angular.extend(model, {
					files: [],
				});
			}

			let promises = [];
			if (files && files.length) {
				angular.forEach(files, function(file) {
					promises.push(Upload.upload({
						url: 'api/file/upload',
						data: {
							file: file,
							nitro: true, // upload to nitro files
						}
					}));
				});

				$q.all(promises).then(function(responses) {
					angular.forEach(responses, function(response) {
						model.files.push(response.data.file);
					});

					$timeout(function() {
						model.isDragging = false;
						model.uploadingInProgress = false;
					});
				}, function(errors) {
					$timeout(function() {
						model.isDragging = false;
						model.uploadingInProgress = false;
					});
				});
			}
		}

		function onMarkTechNotificationConfirmed(jobId) {
			return SMJobSvc.confirmTechnicianJobNotification(jobId)
				.then(function () {
					SMJobSvc.unconfirmedTechnicianJobNotifications()
						.then((response) => {
							self.techNotifications = response.data.job_collection;
						});
				});
		}

		function onAcceptDeclineInvite(task, status) {
			$ngBootbox.confirm('Are you sure you want to ' + status + ' this invite?')
				.then(function () {
					let params = {
						task: task,
						status: status,
					};

					return WorkflowTaskSvc.acceptDeclineTraingingInvite(params).then(function(response) {
						if (status === 'accept') {
							angular.extend(task.training_franchises[0], {
								pivot: {
									accepted_at: moment(),
									declined_at: null,
								}
							});
						}
						else {
							angular.extend(task.training_franchises[0], {
								pivot: {
									accepted_at: null,
									declined_at: moment()
								}
							});
						}
						angular.extend(task, {
							status: response.data.status,
						});

					});
				})
		}


	});